// @flow

import {ofType, StateObservable} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {ActionCreator, buildCatchError, createReducer} from '../../store/utils';
import {
  fetchCountriesApi,
  getStoreCountryApi,
  saveStoreCountryApi,
} from './api';

import type {Action} from '../../store/utils';
import type {ActionObservable} from 'redux-observable';
import type {Country} from '../../entities';
import {GetSessionSuccess, LoginSuccess} from '../auth/duck';
// import {FetchStoreSuccess} from '../store/duck';
import {debounceTime} from 'rxjs/operators';

export type CountryAction = Action & {
  error?: string,
  storeId?: string,
  countryId?: string,
};

export type CountryState = {
  error?: string,
  isGettingStoreCountry?: boolean,
  isFetchingCountries?: boolean,
  countries?: Country[],
  fetchCountriesError?: boolean,
  country?: Country,
  fetchCountryError?: 'string',
};

export class FetchCountries extends ActionCreator<CountryAction> {}
export class FetchCountriesSuccess extends ActionCreator<CountryAction> {}
export class FetchCountriesErrorFn extends ActionCreator<CountryAction> {}
export class GetStoreCountry extends ActionCreator<CountryAction> {}
export class GetStoreCountrySuccess extends ActionCreator<CountryAction> {}
export class GetStoreCountryErrorFn extends ActionCreator<CountryAction> {}
export class SaveStoreCountry extends ActionCreator<CountryAction> {}
export class SaveStoreCountrySuccess extends ActionCreator<CountryAction> {}
export class SaveStoreCountryErrorFn extends ActionCreator<CountryAction> {}

export const actions = {
  fetchCountries: () => new FetchCountries(),
  getStoreCountry: (payload: CountryAction) => new GetStoreCountry(payload),
  saveStoreCountry: (payload: CountryAction) => new SaveStoreCountry(payload),
};

export const initialState = {
  isFetchingCountries: true,
};

export default createReducer<CountryState>(initialState, {
  [FetchCountries.type]: state => ({
    ...state,
    isFetchingCountries: true,
    fetchCountriesError: undefined,
  }),
  [FetchCountriesSuccess.type]: (state, action: CountryAction) => ({
    ...state,
    isFetchingCountries: undefined,
    countries: action.countries,
  }),
  [FetchCountriesErrorFn.type]: state => ({
    ...state,
    isFetchingCountries: undefined,
    fetchCountriesError: true,
  }),
  [GetStoreCountry.type]: state => ({
    ...state,
    isGettingStoreCountry: true,
    fetchCountryError: undefined,
  }),
  [GetStoreCountrySuccess.type]: (state, action: CountryAction) => ({
    ...state,
    isGettingStoreCountry: undefined,
    fetchCountryError: undefined,
    country: action.country,
  }),
  [GetStoreCountryErrorFn.type]: (state, action: CountryAction) => ({
    ...state,
    country: undefined,
    isGettingStoreCountry: undefined,
    fetchCountryError: action.error,
  }),
  [SaveStoreCountry.type]: state => ({
    ...state,
    isSavingStoreCountry: true,
    error: undefined,
  }),
  [SaveStoreCountrySuccess.type]: (state, action: CountryAction) => ({
    ...state,
    isSavingStoreCountry: undefined,
    error: undefined,
  }),
  [SaveStoreCountryErrorFn.type]: (state, action: CountryAction) => ({
    ...state,
    isSavingStoreCountry: undefined,
    error: action.error,
  }),
});

export const saveStoreCountryEpic = (action$: ActionObservable) => {
  return action$.pipe(
    ofType(SaveStoreCountry.type),
    switchMap(({countryId}) => {
      return saveStoreCountryApi({countryId}).pipe(
        map(() => new SaveStoreCountrySuccess()),
        buildCatchError(SaveStoreCountryErrorFn)
      );
    })
  );
};

export const fetchCountriesEpic = (action$: ActionObservable) => {
  return action$.pipe(
    ofType(FetchCountries.type, LoginSuccess.type, GetSessionSuccess.type),
    switchMap(() => {
      return fetchCountriesApi().pipe(
        map((countries: Country[]) => new FetchCountriesSuccess({countries})),
        buildCatchError(FetchCountriesErrorFn)
      );
    })
  );
};

export const getStoreCountryEpic = (
  action$: ActionObservable,
  state$: StateObservable
) => {
  return action$.pipe(
    ofType(
      LoginSuccess.type,
      GetSessionSuccess.type,
      // FetchStoreSuccess.type,
      SaveStoreCountrySuccess.type
    ),
    debounceTime(250),
    // filter(() => {
    //   return (
    //     state$.value &&
    //     state$.value.auth.user &&
    //     state$.value.store.store &&
    //     !state$.value.store.store.initialConfig
    //   );
    // }),
    switchMap(() => {
      return getStoreCountryApi().pipe(
        map((country: Country) => new GetStoreCountrySuccess({country})),
        buildCatchError(GetStoreCountryErrorFn)
      );
    })
  );
};
